module.exports = __webpack_public_path__ + "media/images/restaurant/areas/hokkaido-b1d3d6f783f2837db3ae4a3818e9eddf.png";